import { EDIT_LAYOUT_DATA, EDIT_LAYOUT_TYPES } from './editLayoutStyle.constants';

export const getV2Layouts = () => EDIT_LAYOUT_DATA.filter((item) => item.version === '2.0').map((item) => item.layoutType);

export const getV3Layouts = () => EDIT_LAYOUT_DATA.filter((item) => item.version === '3.0').map((item) => item.layoutType);

export const isV2Layout = (layoutType) => getV2Layouts().includes(layoutType);

export const isV3Layout = (layoutType) => getV3Layouts().includes(layoutType);

export const isV2TwoColumnsLayout = (layoutType) => [
  EDIT_LAYOUT_TYPES.left_align,
  EDIT_LAYOUT_TYPES.right_align,
].includes(layoutType);

export const isV2OneColumnLayout = (layoutType) => EDIT_LAYOUT_TYPES.one_column === layoutType;
